var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('el-tree',{attrs:{"data":_vm.treeData,"props":{children:'children', label:'name'},"default-expand-all":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('span',{staticClass:"custom-tree-node"},[_c('span',[_vm._v(_vm._s(node.label)+"\n                    "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("  "+_vm._s(data.remark))]),_vm._v("  ----【"+_vm._s(data.typeCN)+"】\n                ")]),_vm._v(" "),(data.children&&data.children.length>0)?_c('span'):_vm._e()])}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c167976","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/user/components/FeatureShow.vue
// module id = null
// module chunks = 